import {
  fromJS
} from 'immutable';
import {
  handleActions
} from 'redux-actions';
import * as Types from '../actions/constants';

const INITIAL_STATE = fromJS({
  submitting: false,
  fields: {
    nombre: {
      value: '',
      errors: []
    },
    apellido: {
      value: '',
      errors: []
    },
    dni: {
      value: '',
      errors: []
    }
  },
  error: null
});

const personasUpsertReducer = handleActions({
  [Types.UPSERT_PERSONA_ATTEMPT]: (state, action) => state.merge({
    submitting: true,
    error: null
  }),
  [Types.UPSERT_PERSONA_SUCCESS]: (state, action) => state.merge({
    submitting: false
  }),
  [Types.UPSERT_PERSONA_FAILURE]: (state, action) => state.merge({
    submitting: false,
    error: action.payload
  }),
  [Types.PERSONA_VALIDATION_ERROR]: (state, action) => state.set(
    'fields',
    state.get('fields').mergeWith((field, errors) => {
      return field.set('errors', errors);
    }, action.payload.errors)
  ),
  [Types.CHANGE_PERSONA_FORM_VALUE]: (state, action) => state.set(
    'fields',
    state.get('fields').setIn([action.payload.name, 'value'], action.payload.value)
  ),
  [Types.RESET_PERSONA_FORM]: (state, action) => INITIAL_STATE
}, INITIAL_STATE);


export default personasUpsertReducer;



// WEBPACK FOOTER //
// ./client/store/reducers/personasUpsertReducer.js